import React, { Component } from 'react'
import Activity from "framework/containers/Activity"

//redux
import { connect } from 'react-redux'
import { mapStateToProps, mapDispatchToProps } from 'framework/utils/Redux'

class FingerprintConfigurationClientActivity extends Component {

	constructor(props){
		super(props)
		this.RenderedComponent = import("app/components/Hr/Client/ClientBrowser")
	}

	render() {
		return (
			<Activity 
				name="FingerprintConfigurationClient"
				RenderedComponent={this.RenderedComponent}
				context="FingerprintConfigurationClient"
			/>
		)
	}
}

export default connect(mapStateToProps,mapDispatchToProps)(FingerprintConfigurationClientActivity)
